import { Field, useFormikContext } from 'formik';
import React, { useCallback, useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { FormikSelect } from '../../../../components';
import { searchEmployeeRequest } from '../../../../requests/employees';
import { camelCaseEmptyStringRecursive } from '../../../../services/utils';

export default function AvancedFilerInput({ fetchEmployees }) {
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const [selector, setSelector] = useState([]);
  const dispatch = useDispatch();

  const searchEmployeesParams = useCallback(() => {
    const request = async () =>
      searchEmployeeRequest({
        params: {
          sort_column: 'name',
          paginate: false,
          advance: false
        },
        dispatch,
        successCallback: response => setSelector(camelCaseEmptyStringRecursive(response.data.data))
      });
    request();
  }, [dispatch]);

  const fetchEmployeesFilter = searchValues => {
    if (searchValues === '' || searchValues.length === 0) {
      setFieldValue('settlementGroup[employees]', []);
      setFieldValue('settlementGroup[employeeIds]', []);
      return [];
    }
    const params = {
      filter_active_job_titles: [],
      filter_active_branch_offices: [],
      filter_active_job_managements: [],
      filter_active_syndicates: [],
      filter_active_cost_centers: []
    };
    searchValues.forEach(value => params[value.queryValue].push(value.value.split('-')[1]));
    return fetchEmployees(params);
  };

  useEffect(() => {
    searchEmployeesParams();
  }, [searchEmployeesParams]);

  return (
    <Col xl={6} xs={12} md={6} lg={6}>
      <Field name="settlementGroup[filter]">
        {({ field }) => (
          <FormikSelect
            {...field}
            label="Buscar Empleados"
            options={selector}
            defaultValue={values.settlementGroup.filter?.value}
            value={values.settlementGroup.filter?.value}
            onChange={data => {
              fetchEmployeesFilter([data] || '');
              setFieldValue(field.name, data || '');
            }}
            setFieldTouched={() => setFieldTouched(field.name)}
          />
        )}
      </Field>
    </Col>
  );
}
